export const consultantRoute = {
  CONSULTANT_LIST: '/consultant/list',
  CONSULTANT_DETAIL: '/consultant/detail/:recordId',
  CONSULTANT_SETTING: '/setting/consultant'
};
